import {
    IWorkbenchService,
    LoaderType,
} from '@src/slide/application/service/workbench-service/core/workbench-service.interface';
import {
    IWorkbenchInjectable,
} from '@src/slide/application/service/workbench-service/inject/worbench-injectable.interface';
import { WorkbenchLoader } from '@tencent/workbench';

export default class BaseWorkbenchService implements IWorkbenchService {
    private inject: IWorkbenchInjectable;
    /**
     * 加载workbench
     * @param container 添加到的容器
     */
    public loadWorkBench(container: HTMLElement) {
        const loaderPromise =  this.getWorkbenchLoader();
        if (loaderPromise) {
            loaderPromise.then((loader) => {
                this.load(loader, container);
            });
        }
    }

    /**
     * 注入inject
     * @param inject
     */
    public setWorkbenchInject(inject: IWorkbenchInjectable) {
        this.inject = inject;
    }

    protected load(loader: LoaderType<WorkbenchLoader>, container: HTMLElement) {
        // 子类实现
    }

    private async getWorkbenchLoader(): Promise<LoaderType<WorkbenchLoader>> {
        return await this.inject.getWorkbenchLoader();
    }
}
